module.exports = __webpack_public_path__ + "static/media/emptyState.a1ae9279.svg";